export const MODALE_TITLE = 'Редактирование'
export const MODALE_SUBMITE = 'Применить'
export const MODALE_CANCEL = 'Отмена'

export const columnsForAccrualTable = [
	{
		name: 'Выдано',
		prop: 'isDoneForPayroller',
	},
	{
		name: 'Дата',
		prop: 'dateAccrual',
	},
	{
		name: 'ФИО',
		prop: 'name',
	},
	{
		name: 'Аванс',
		prop: 'salaryA',
	},
	{
		name: 'Отпускные/БЛ',
		prop: 'salaryO',
	},
	{
		name: 'З/П',
		prop: 'salary',
	},
	{
		name: 'Премия',
		prop: 'premium',
	},
	{
		name: 'Выезды',
		prop: 'ride',
	},
	{
		name: 'Переработки',
		prop: 'owertime',
	},
	{
		name: 'Командировочные',
		prop: 'businessTrip',
	},
	{
		name: 'Обед',
		prop: 'lunch',
	},
	{
		name: 'ГСМ',
		prop: 'fuel',
	},
	{
		name: 'Амортизация',
		prop: 'amortisation',
	},
	{
		name: 'Топливная карта',
		prop: 'fuelCard',
	},
	{
		name: 'Фитнес',
		prop: 'fitness',
	},
	{
		name: 'Страховка',
		prop: 'insurance',
	},
	{
		name: 'Удержания',
		prop: 'mulct',
	},
	{
		name: 'Возврат кредита',
		prop: 'credit',
	},
	{
		name: 'Сумма к выплате',
		prop: 'total',
	},
	{
		name: 'Долг перед компанией',
		prop: 'creditTotal',
	},
]
export const ACCRUAL_TYPES = ['Аванс', 'Зарплата', 'Отпуск/БЛ']
